module.exports = __webpack_public_path__ + "img/arkafort-logo-grey.74ae9de9.svg";